<div class="px-4" style="margin-top: 18px;">
  <h4>Notifications</h4>
  <div class="my-5 text-center">
    <fa-icon [icon]="['far', 'umbrella-beach']" class="text-warning" size="10x"></fa-icon>
    <h4 class="mt-4">Inbox zero!</h4>
    <h6 class="text-muted mt-3">No notifications right now</h6>
  </div>
</div>
